import Sidebar from '../Components/Sidebar'
import Dashboardlayout from '../Components/Dashboardlayout'
export default function MainShopifyLink() {
  return (
    <div className="flex ">
    <Sidebar />
   <Dashboardlayout/>
  </div>
  )
}
